import React, { Component } from 'react'
import Img from 'gatsby-image'
import axios from 'axios'
import Helmet from 'react-helmet'
import { backendURL } from '../data/config.json'

class FaqsEs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
    }
    this.handleToogle = this.handleToogle.bind(this)
    this.renderFaqs = this.renderFaqs.bind(this)
  }
  componentDidMount() {
    axios.get(`${backendURL}/api/faqs`).then(res => {
      this.setState({
        loading: false,
        faqs: res.data,
      })
      axios
        .get(`${backendURL}/api/banners/page/Faqs`)
        .then(res => {
          const main = res.data.filter(data => data.section === 'Main')
          if (main[0]) {
            this.setState(prevState => {
              return {
                ...prevState,
                loading: false,
                mainImageEs: {
                  title: main[0].title.es,
                  url: main[0].imageEs,
                },
              }
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    })
  }
  handleToogle(e) {
    const { checked: value, id } = e.target
    this.setState({
      [id]: value,
    })
  }
  renderFaqs() {
    const { faqs } = this.state
    return _.map(faqs, (faq, i) => {
      const { title, description, published } = faq
      const { langKey: lang } = this.props.pathContext
      if (published) {
        const id = `faq${i}`
        return (
          <div className={!this.state[id] ? 'item on' : 'item off'}>
            <input type="checkbox" id={id} onClick={this.handleToogle} />
            <label for={id}>{title[lang]}</label>
            <div className="excerpt">{description[lang]}</div>
          </div>
        )
        return null
      }
    })
  }
  render() {
    if (this.state.loading) {
      return null
    }
    return (
      <div className="page faqs">
                 <Helmet
            title={`Budget Nicaragua FAQs`}
            meta={[
              {
                name: 'description',
                content:
                  'Preguntas frecuentes sobre el alquiler de autos.',
              },
            ]}
            link={[
              {
                rel: 'alternate',
                hreflang: 'es',
                href:
                  './en/faqs',
              },
            ]}
          />
          {this.state.mainImageEs ? (
          <img
            src={`${backendURL}${this.state.mainImageEs.url}`}
            alt={this.state.mainImageEs.title}
            style={{ width: '100%' }}
            className="top-bg"
          />
        ) : (
          <div />
        )}
        <div className="wrapper">
          <h1>FAQ</h1>
         
          <p>
            En Budget Rent a Car estamos siempre a su disposición para cualquier
            duda o consulta que tenga, a continuación algunas preguntas y
            respuestas o si desea comuníquese con nosotros en el icono de
            CONTACTENOS para ayudarle personalmente.
          </p>

          <div id="accordion">{this.renderFaqs()}</div>
        </div>
      </div>
    )
  }
}

export const query = graphql`
  query FAQEsQuery {
    imageSharp(id: { regex: "/faq-top-background/" }) {
      sizes(maxWidth: 1600) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`

export default FaqsEs



// WEBPACK FOOTER //
// ./src/pages/faqs.es.js